import { PREFIX } from './config.js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';


gsap.registerPlugin( ScrollTrigger , SplitText );

function setAnimation( el ){
  const split = new SplitText( el , {
    type: 'words',
    wordsClass: 'sp-word',
  });
  const words = split.words;
  gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: 'top 90%',
      end: 'bottom 40%',
      scrub: true,
    },
  }).to(words, {
    duration: 0.3,
    stagger: {
      amount: 0.5,
      onStart: function () {
        const currentWord = this.targets()[0];
        currentWord.classList.add('active');
      },
      onReverseComplete: function () {
        const currentWord = this.targets()[0];
        currentWord.classList.remove('active');
      },
    },
  });
}

function initSplitText( ){
  document.querySelectorAll( `[data-${PREFIX ?? 'wphack'}-split]` ).forEach( el => {
    let type = el.dataset[`${PREFIX ?? 'wphack'}Split`];
    console.log( type , el.dataset )
    if( type === 'single' ){
      setAnimation( el );
    } else {
      Array.from( el.children ).forEach( sub => {
        setAnimation( sub );
      });
    }
  });
}

export { initSplitText };
